import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtpChatComponent } from './atp-chat.component';
import {ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {AtpTitleModule} from "../atp-title/atp-title.module";
import {MatInputModule} from "@angular/material/input";



@NgModule({
  declarations: [AtpChatComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    AtpTitleModule,
    MatInputModule
  ],
  exports: [
    AtpChatComponent
  ]
})
export class AtpChatModule { }
